var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"background-overlay fixed top-0 left-0 h-full w-full",class:[_vm.showDrawerBoolean ? '' : 'hidden'],on:{"click":function($event){return _vm.$emit('update:showDrawerBoolean', false)}}})}
var staticRenderFns = []

export { render, staticRenderFns }